import Player from '@vimeo/player';
import { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import { setVideoWatchedById } from '@/store/slices/video/seriesSlice';
import { setVideoWatchedFlag } from '@/store/slices/video/videoSlice';
import { useSearchParams } from 'react-router-dom';
import { updateVideoWatchCountApiCall, updatePublicPrivateVideoViewCount } from "@/services/api"
import VideoPlayerMainView from "./view";
import { isIOS } from '@/utils';

import Pause from "@/assets/icons/pause.png"
import Play from "@/assets/icons/play.png"

import MiniPause from "@/assets/icons/miniPause.png"
import MiniPlay from "@/assets/icons/miniPlay.png"

import CcOnIcon from '@/assets/icons/ccOn.png';
import CcOffIcon from '@/assets/icons/ccOff.png';

import Volume from '@/assets/icons/volume.png';
import Mute from '@/assets/icons/mute.png';

import Speed_025 from '@/assets/icons/speed_025.png';
import Speed_05 from '@/assets/icons/speed_05.png';
import Speed_075 from '@/assets/icons/speed_075.png';
import Speed_1 from '@/assets/icons/speed_1.png';
import Speed_125 from '@/assets/icons/speed_125.png';
import Speed_15 from '@/assets/icons/speed_15.png';
import Speed_175 from '@/assets/icons/speed_175.png';
import Speed_2 from '@/assets/icons/speed_2.png';

import FullScreen from "@/assets/icons/fullScreen.png"
import SmallScreen from "@/assets/icons/smallScreen.png"
import { useAuthToken } from '@/hooks/useAppSelectors';
import { addCurrentThemeClassToEle } from '@/utils';


export default function VideoPlayerMain(props: any) {
    const dispatch = useDispatch();
    const token = useAuthToken()
    const [searchParams] = useSearchParams();

    const [playerIsLoading, setPlayerIsLoading] = useState(true);
    const [finalIsLoading, setFinalIsLoading] = useState(true);

    const screenWidth = useSelector((state: RootState) => state.screenWidthReducer.screenWidth);
    const videoDetails = useSelector((state: RootState) => state.videoReducer.video);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    const vimeoApiPlayerRef = useRef<Player | null>(null);
    const playerContainerRef = useRef<HTMLDivElement | null>(null);

    const domVideoElementRef = useRef<HTMLDivElement | null>(null);

    const [isMouseIn, setIsMouseIn] = useState(false);
    const [showControls, setShowControls] = useState(false);

    const videoIsPlaying = useRef(false);
    const [playPauseIcon, setPlayPauseIcon] = useState("");
    const [miniPlayPauseIcon, setMiniPlayPauseIcon] = useState<any>(null);

    const [isVisibleBackwardIcon, setIsVisibleBackwardIcon] = useState(false);
    const [isVisibleForwardIcon, setIsVisibleForwardIcon] = useState(false);


    const miniBackwardBtnRef: any = useRef(null)
    const miniPlayPauseBtnRef: any = useRef(null)
    //START : States to handle speed
    const speedList = {
        "0.25x": 0.25,
        "0.5x": 0.5,
        "0.75x": 0.75,
        "1x": 1,
        "1.25x": 1.25,
        "1.5x": 1.5,
        "1.75x": 1.75,
        "2x": 2,
    }
    const speedConRef: any = useRef(null)
    const [speedValue, setSpeedValue] = useState(1);
    const [speedIcon, setSpeedIcon] = useState(Speed_1);
    //END : States to handle speed


    //START : States to handle qty
    const [availableQualities, setAvailableQualities] = useState([])
    const qtyConRef: any = useRef(null)
    const [qtyValue, setQtyValue] = useState("auto");
    const qtyImgIconRef: any = useRef(null)
    //END : States to handle qty



    //START : States to handle CC
    const isHasCaptions = useRef(false);
    const [ccIcon, setCCIcon] = useState(CcOffIcon);
    //START : States to handle CC


    //START : States to handle video time fns
    const timeBarRef = useRef<any>(null);
    // Note the value will will be updated from init video player are set using useRef
    const currentVideoDurationInSeconds = useRef(0);
    const [timeBarChangePer, setTimeBarChangePer] = useState('0%');
    const [currentVideoTime, setCurrentVideoTime] = useState('00:00');
    const [videoDuration, setVideoDuration] = useState('00:00');
    const maxVideoDuration = useRef(0);
    //END : States to handle video time fns


    //START : States to handle volume
    const volumeBarRef = useRef<any>(null);
    const [volumeBarChangePer, setVolumeBarChangePer] = useState('0%');
    const previousVolume = useRef(0)
    const [volumeIcon, setVolumeIcon] = useState(Volume);
    //END : States to handle volume


    // START : States of Fullscreen states
    const [fullSmallScreenIcon, setFullSmallScreenIcon] = useState(FullScreen)
    // END : States of Fullscreen states


    // START : Inactivity detection states
    const inactivityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const INACTIVITY_TIMEOUT_MS = 3000; // 5 seconds
    // END : Inactivity detection states


    const [seriesId, setSeriesId] = useState(searchParams.get("series"));
    const isSubscribedSeries = searchParams.get("subscription") === "true";
    const hasTriggeredWatchCount = useRef(false);
    const hasRiggeredViewCount = useRef(false);


    const [isManualFullscreen, setIsManualFullscreen] = useState(false);


    useEffect(() => {
        if (!props.isLoading && !playerIsLoading) {
            setFinalIsLoading(false)
            // setFinalIsLoading(true)  // tetsing xxpx
        }
    }, [playerIsLoading])


    // test : 641023491(emedskill public), 252443587, 758682785(for caption)
    // const videoId = 641023491
    /** Re-init only when the actual Vimeo embed / lesson changes — not when e.g. `isWatched` updates on the same video. */
    const vimeoEmbedId = videoDetails?.videoId;
    const videoDocIdForPlayer = videoDetails?._id;

    useEffect(() => {
        initVideoPlayer()

        return () => {
            if (vimeoApiPlayerRef.current) {
                vimeoApiPlayerRef.current.destroy().then(() => {
                    //Reset speed
                    setSpeedIcon(Speed_1);
                    setSpeedValue(1)
                    console.log('Vimeo player destroyed.');
                }).catch((error) => {
                    console.error('Error destroying Vimeo player:', error);
                });
            }
        };
    }, [vimeoEmbedId, videoDocIdForPlayer])


    useEffect(() => {
        // window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

        const handleKeyPress = (event: KeyboardEvent) => {
            const key = event.key;

            if (
                key === ' ' ||
                key === 'ArrowLeft' ||
                key === 'ArrowRight' ||
                key === 'ArrowUp' ||
                key === 'ArrowDown' ||
                key === 'm' ||
                key === 'M' ||
                key === 'f' ||
                key === 'F'
            ) {
                if (
                    !(event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement)
                ) {
                    event.preventDefault();

                    switch (key) {
                        case ' ':
                            handlePlayPauseOfVideo('spaceBar');
                            break;
                        case 'ArrowLeft':
                            handleBackward10();
                            break;
                        case 'ArrowRight':
                            handleForward10();
                            break;
                        case 'ArrowUp':
                            updateVolueFromKeyPress("ArrowUp");
                            break;
                        case 'ArrowDown':
                            updateVolueFromKeyPress("ArrowDown");
                            break;
                        case 'm':
                        case 'M':
                            updateVolueFromKeyPress("mute");
                            break;
                        case 'f':
                        case 'F':
                            toggleFullscreen();
                            break;
                        default:
                            break;
                    }
                }
            }
        };
        document.addEventListener('keydown', handleKeyPress);


        // Fullscreen change listener
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('msfullscreenchange', handleFullscreenChange);


        // Inactivity listeners
        document.addEventListener('mousemove', resetInactivityTimer);
        document.addEventListener('keydown', resetInactivityTimer);
        document.addEventListener('click', resetInactivityTimer);
        document.addEventListener('touchstart', resetInactivityTimer);

        return () => {
            document.removeEventListener('keydown', handleKeyPress);

            // Cleanup fullscreen event listeners
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('msfullscreenchange', handleFullscreenChange);


            // Cleanup inactivity event listeners
            document.removeEventListener('mousemove', resetInactivityTimer);
            document.removeEventListener('keydown', resetInactivityTimer);
            document.removeEventListener('click', resetInactivityTimer);
            document.removeEventListener('touchstart', resetInactivityTimer);
        };
    }, []);



    // START : fn to handle the viewablity of controls
    useEffect(() => {
        handleShowControl()
    }, [isMouseIn, videoIsPlaying.current])
    const handleShowControl = () => {
        // debugger
        let overLay = false
        if (isMouseIn || !videoIsPlaying.current) {
            overLay = true
        }
        setShowControls(overLay)

        if (!isMouseIn || videoIsPlaying.current) {
            setIsVisibleBackwardIcon(false)
            setIsVisibleForwardIcon(false)
        }

        if (!overLay) {
            setDisplayOfSpeedConRef("none")
            setDisplayOfQtyConRef("none")
        }

    }
    const handleMouseEnter = () => {
        setIsMouseIn(true)
    };

    const handleMouseLeave = () => {
        setIsMouseIn(false)
    };
    // END : fn to handle the viewablity of controls



    // ======= START : init fns video =======
    const initVideoPlayer = () => {
        // const isIOS_ = isIOS();
        // const isIOS_ = true; // testing

        if (videoDetails && videoDetails.videoId) {
            hasTriggeredWatchCount.current = false
            hasRiggeredViewCount.current = false
            setFinalIsLoading(true)
            setPlayerIsLoading(true);
            const options = {
                id: Number(videoDetails.videoId),
                // loop: true, // to get video ended api call from video else we won't get it
                controls: false,
                autoplay: true,
                muted: false,
                responsive: true,
                texttrack: '(en-US)',
                playsinline: true
            };

            // console.log(isIOS_, "isIOS_")

            const options_v1 = {
                id: Number(videoDetails.videoId),
                loop: true,
                controls: false,
                // autoplay: isIOS_ === true ? false : true,
                muted: false,
                responsive: true,
                texttrack: '(en-US)',
                playsinline: true
            };

            // console.log(options, "options")


            if (domVideoElementRef.current) {
                vimeoApiPlayerRef.current = new Player(domVideoElementRef.current, options);
                vimeoApiPlayerRef.current
                    .ready()
                    .then(() => {

                        // if(isIOS_ === true){
                        //     setPlayerIsLoading(false);
                        //     setShowControls(true);
                        //     setMiniPlayPauseIcon(MiniPause)
                        //     setPlayPauseIcon(Pause)
                        // }

                        vimeoApiPlayerRef.current?.on('play', () => {
                            setPlayerIsLoading(false);
                            handleUpdatePublicPrivateVideoViewCount()
                        });

                        // console.log('sw')
                        // //@ts-ignore
                        // vimeoApiPlayerRef.current?.getVideoThumbnails().then((thumbnails: any[]) => {
                        //     console.log('Thumbnails:', thumbnails);
                        // });

                        //Set init video
                        handleInitPlayPauseIcon();

                        //Fn to manage video time fns
                        vimeoApiPlayerRef.current?.on('timeupdate', (data) => {
                            handleTimeline(data);
                        });

                        //Fn to update video duration
                        updateVideoCompleteDuration();

                        // Fn to handle seekbar when screen loads
                        handleInitSeekbar();

                        // NEW: Get and set available qualities
                        handleGetQty();

                        //Set captions
                        checkForCaptions();

                        //Set in volume volume
                        setInitVolume()

                        //Set event to close popups
                        document.addEventListener('mousedown', handleOutsideClick);


                        vimeoApiPlayerRef.current?.on('ended', () => {
                            props.playNextVideo()
                        });                        

                    })
                    .catch((err) => {
                        alert('Requested Video Not Found: Connect With eMediskill Team');
                    });


            } else {
                console.log("no ref found")
            }
        }
    }



    const handleInitSeekbar = () => {
        if (timeBarRef && timeBarRef.current) {
            let changedValue = 0;
            timeBarRef.current.value = changedValue.toString();
        }
    };
    // ======= START : init fns video =======



    // ======= START : Fns to manage video timeline =======
    const updateVideoCompleteDuration = () => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current
                .getDuration()
                .then(function (duration) {
                    maxVideoDuration.current = duration;
                    timeBarRef.current.max = duration;
                    setVideoDuration(formatTime(duration));
                    // sendVideoDuration(duration);
                })
                .catch(function (error) {
                    console.log('getDuration : ', error);
                });
        }
    };
    const handleTimeline = (data: any) => {
        // For ref : const { seconds, duration, percent } = data;
        const { seconds, duration } = data;
        currentVideoDurationInSeconds.current = duration
        setCurrentVideoTime(formatTime(seconds));

        timeBarRef.current.value = seconds.toString();
        const progress =
            ((seconds - 0) / (maxVideoDuration.current - 0)) * 100;

        let bgPercentage = progress + '%';
        setTimeBarChangePer(bgPercentage);


        handleWatchCountUpdate(seconds, duration);
    }


    const handleWatchCountUpdate = async (seconds: any, duration: any) => {
        if (token) {
            if (!hasTriggeredWatchCount.current) {
                const secondsLeft = duration - seconds;
                const twoMinutes = 2 * 60;
                /** Long videos: last 2 minutes. Shorter ones: last ~15s so we do not fire at t=0 when duration < 2m. */
                const nearEnd =
                    duration > 0 &&
                    (duration > twoMinutes
                        ? secondsLeft <= twoMinutes
                        : secondsLeft <= 15);

                if (nearEnd) {
                    hasTriggeredWatchCount.current = true;
                    let payload = {
                        seriesId: seriesId,
                        videoDocId: videoDetails?._id,
                        isWelcomeSeries: props.isWelcomeSeries,
                        isSubscribedSeries,
                    }
                    const updateVideoWatchCountApiCallStatus = await updateVideoWatchCountApiCall(payload)
                    if (updateVideoWatchCountApiCallStatus.status) {
                        const vid = videoDetails?._id;
                        if (vid) {
                            dispatch(
                                setVideoWatchedById({
                                    videoDocId: vid,
                                    isWatched: true,
                                })
                            );
                            dispatch(setVideoWatchedFlag(true));
                        }
                    } else {
                        hasTriggeredWatchCount.current = false;
                        console.log("issue in handleWatchCountUpdate")
                    }
                }
            }
        }
    }


    const handleUpdatePublicPrivateVideoViewCount = async () => {
        if (!hasRiggeredViewCount.current) {
            if (videoDetails && videoDetails.videoId) {
                const isPublic = token ? false : true
                let payload = {
                    videoDocId: videoDetails?._id,
                    seriesId: seriesId,
                    isWelcomeSeries: props.isWelcomeSeries,
                    isWelcomeOfferVideo: Boolean(props.isWelcomeSeries),
                    isSubscribedVideo: isSubscribedSeries,
                }
                hasRiggeredViewCount.current = true
                const updateVideoWatchCountApiCallStatus = await updatePublicPrivateVideoViewCount(payload, isPublic)
                if (!updateVideoWatchCountApiCallStatus.status) {
                    console.log("issue in handleUpdatePublicPrivateVideoViewCount")
                }
            }
        }
    }


    const handleTimeBarRefChange = (event: any) => {
        let changedValue = parseFloat(event.target.value);

        if (vimeoApiPlayerRef.current) {
            timeBarRef.current.value = changedValue.toString();
            const percent =
                ((changedValue - 0) / (maxVideoDuration.current - 0)) * 100;
            let bgPercentage = percent + '%';
            setTimeBarChangePer(bgPercentage);

            vimeoApiPlayerRef.current.setCurrentTime(changedValue).then(() => {
                // timeBarRef.current.value = changedValue.toString();
                // const percent =
                //     ((changedValue - 0) / (maxVideoDuration.current - 0)) * 100;
                // let bgPercentage = percent + '%';
                // setTimeBarChangePer(bgPercentage);
            });
        }
    };


    const formatTime = (duration: any) => {
        const hours = Math.floor(duration / 3600);
        const minutes = Math.floor((duration % 3600) / 60);
        const seconds = Math.floor(duration % 60);

        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        if (hours > 0) {
            return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        } else {
            return `${formattedMinutes}:${formattedSeconds}`;
        }
    };
    // ======= END : Fns to manage video time timeline =======



    // ======= START : fns to handle timing of video =======
    const handleInitPlayPauseIcon = () => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current.on('play', () => {
                togglePlayPause('paused');
            });

            vimeoApiPlayerRef.current.on('pause', () => {
                togglePlayPause('play');
            });
        }
    };

    const togglePlayPause = (status: string) => {
        if (status === 'play') {
            videoIsPlaying.current = false
            setPlayPauseIcon(Pause)
            setMiniPlayPauseIcon(MiniPause)
        } else {
            videoIsPlaying.current = true
            setPlayPauseIcon(Play)
            setMiniPlayPauseIcon(MiniPlay)
        }
    };

    const handlePlayPauseOfVideo = (source: string) => {
        // debugger
        if (vimeoApiPlayerRef.current) {

            // To mimic click on video container
            // debugger
            if (isInTabView()) {
                setIsMouseIn(true)
                setTimeout(() => {
                    setIsMouseIn(false)
                }, 4000)

                if (source === "click") {
                    return
                }
            }

            vimeoApiPlayerRef.current.getPaused().then((paused) => {
                if (paused) {
                    // console.log('Currently paused, playing...');
                    vimeoApiPlayerRef.current?.play();
                    togglePlayPause("play")
                } else {
                    // console.log('Currently playing, pausing...');
                    vimeoApiPlayerRef.current?.pause();
                    togglePlayPause("pause")
                }
            });
        }
    }


    const handleBackward10 = (event: any = null) => {
        if (event) {
            event.stopPropagation();
        }
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current
                .getCurrentTime()
                .then((response) => {
                    const currentTime = response;
                    if (currentTime > 12) {
                        vimeoApiPlayerRef.current?.setCurrentTime(currentTime - 10);

                        // START : Code to show and hide center div forward icon
                        setIsVisibleForwardIcon(false);
                        setIsVisibleBackwardIcon(true);
                        setTimeout(function () {
                            setIsVisibleBackwardIcon(false);
                        }, 1500);
                        // END : Code to show and hide center div forward icon
                    }
                })
                .catch((error) => {
                    console.log('backward10 : ', error);
                });
        }
    };

    const handleForward10 = (event: any = null) => {
        if (event) {
            event.stopPropagation();
        }

        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current
                .getCurrentTime()
                .then((currentTime) => {
                    const targetTime = currentTime + 10;

                    if (targetTime > currentVideoDurationInSeconds.current) {
                        console.log("Reached end — go to next video");
                        // START : Code to play next video
                        // if (timeBarRef.current) {
                        //     timeBarRef.current.value = 0;
                        //     setTimeBarChangePer('0%');
                        // }
                        // handleNextVideo(videoId);
                        //END : Code to play next video
                        return;
                    }

                    vimeoApiPlayerRef.current?.setCurrentTime(targetTime);

                    setIsVisibleBackwardIcon(false);
                    setIsVisibleForwardIcon(true);
                    setTimeout(() => {
                        setIsVisibleForwardIcon(false);
                    }, 1500);
                })
                .catch((error) => {
                    console.log("forward10 :", error);
                });
        }
    };
    // ======= END : controls for video =======


    // ======= START : controls for speed =======
    const getStyleOfSpeedConRef = () => {
        let style = ""
        if (speedConRef.current) {
            style = speedConRef.current.style.display
        }
        return style
    }

    const setDisplayOfSpeedConRef = (style: any) => {
        if (speedConRef.current) {
            speedConRef.current.style.display = style
        }
    }

    const handleSpeedContainerVisibility = () => {
        if (speedConRef.current) {

            if (isInMobileView()) {
                if (qtyImgIconRef.current) {
                    const currentDisplayOfSpeedConRef = getStyleOfSpeedConRef();
                    if (currentDisplayOfSpeedConRef !== "block") {
                        setDisplayOfQtyConRef("none")
                        let marginLeft = qtyImgIconRef.current.getBoundingClientRect().x + "px";
                        speedConRef.current.style.marginLeft = marginLeft
                        setDisplayOfSpeedConRef("block")
                    } else {
                        setDisplayOfSpeedConRef("none")
                    }
                }
                return
            }


            if (miniBackwardBtnRef.current
                && miniPlayPauseBtnRef.current) {
                const currentDisplayOfSpeedConRef = getStyleOfSpeedConRef();
                if (currentDisplayOfSpeedConRef !== "block") {
                    setDisplayOfQtyConRef("none")
                    const miniBackwardBtnRefWidth = miniBackwardBtnRef.current.getBoundingClientRect().width
                    const miniPlayPauseBtnRefWidth = miniPlayPauseBtnRef.current.getBoundingClientRect().width
                    let marginLeft = miniBackwardBtnRefWidth + miniPlayPauseBtnRefWidth + "px";
                    speedConRef.current.style.marginLeft = marginLeft
                    setDisplayOfSpeedConRef("block")
                } else {
                    setDisplayOfSpeedConRef("none")
                }
            }
        }
    }

    const handleSpeed = (event: any, changeSpeed: any) => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current.setPlaybackRate(changeSpeed).then((actualSpeed) => {
                setSpeedValue(actualSpeed);
                if (changeSpeed === 0.25) {
                    setSpeedIcon(Speed_025);
                } else if (changeSpeed === 0.5) {
                    setSpeedIcon(Speed_05);
                } else if (changeSpeed === 0.75) {
                    setSpeedIcon(Speed_075);
                } else if (changeSpeed === 1) {
                    setSpeedIcon(Speed_1);
                } else if (changeSpeed === 1.25) {
                    setSpeedIcon(Speed_125);
                } else if (changeSpeed === 1.5) {
                    setSpeedIcon(Speed_15);
                } else if (changeSpeed === 1.75) {
                    setSpeedIcon(Speed_175);
                } else if (changeSpeed === 2) {
                    setSpeedIcon(Speed_2);
                }
            })
        }
        setDisplayOfSpeedConRef("none")
    };
    // ======= END : controls for speed =======



    // ======= START : fns to control video quality =======
    const getStyleOfQtyConRef = () => {
        let style = ""
        if (qtyConRef.current) {
            style = qtyConRef.current.style.display
        }
        return style
    }

    const setDisplayOfQtyConRef = (style: any) => {
        if (qtyConRef.current) {
            qtyConRef.current.style.display = style
        }
    }

    const handleQtyContainerVisibility = () => {
        if (qtyConRef.current) {

            let valToSub = 140
            if (isInMobileView()) {
                valToSub = 160
            } else if (isInTabView()) {
                valToSub = 130
            }
            // console.log(valToSub)
            if (playerContainerRef.current) {
                const currentDisplayOfQtyConRef = getStyleOfQtyConRef();
                if (currentDisplayOfQtyConRef !== "block") {
                    setDisplayOfSpeedConRef("none")
                    let marginLeft = (playerContainerRef.current.getBoundingClientRect().width - valToSub) + "px";
                    qtyConRef.current.style.marginLeft = marginLeft
                    setDisplayOfQtyConRef("block")
                } else {
                    setDisplayOfQtyConRef("none")
                }
            }
        }

    }

    const handleGetQty = () => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current.getQualities().then((qualities: any) => {
                setAvailableQualities(qualities)
                const activeQuality = qualities.find((item: { active: any; }) => item.active);
                setQtyValue(activeQuality.id)
            }).catch((error) => {
                console.error('Error getting qualities:', error);
            });
        }
    };

    const handleQty = (event: any, qty: any) => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current.setQuality(qty.id).then((actualQty) => {
                setQtyValue(actualQty)
            })
        }
        setDisplayOfQtyConRef("none")
    }
    // ======= END : fns to control video quality =======




    // ======= START : fns to control cc =======
    const checkForCaptions = () => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current
                .getTextTracks()
                .then(function (tracks) {
                    if (tracks.length > 0) {
                        isHasCaptions.current = true
                    }
                })
                .catch(function (error) {
                    console.log('checkForCaptions : ', error);
                });
        }
    };

    const handleCC = () => {
        // debugger
        if (ccIcon === CcOnIcon) {
            disableCC()
        } else {
            enableCC()
        }
    }

    const enableCC = async () => {
        if (vimeoApiPlayerRef.current) {
            try {
                const textTracks = await vimeoApiPlayerRef.current.getTextTracks();
                const captionsTrack = textTracks.find((track) => track.kind === 'captions');
                if (captionsTrack) {
                    vimeoApiPlayerRef.current.enableTextTrack(captionsTrack.language);
                    setCCIcon(CcOnIcon);
                }
            } catch (error) {
                console.error('Error enabling captions:', error);
            }
        }
    };

    const disableCC = () => {
        if (vimeoApiPlayerRef.current) {
            try {
                vimeoApiPlayerRef.current.disableTextTrack();
                setCCIcon(CcOffIcon);
            } catch (e) {
                console.log('disableCC : ', e);
            }
        }
    };
    // ======= END : fns to control cc =======



    // ======= START : fns to volumne =======
    const setInitVolume = () => {
        // xxpx
        const isIOS_ = isIOS();
        if (isIOS_) {
            if (vimeoApiPlayerRef.current) {
                previousVolume.current = 1;
                setVolumeIcon(Mute);
                vimeoApiPlayerRef.current.setMuted(true);
            }
        } else {
            handleVolumeChange(null, 1)
        }
    }

    const updateVolueFromKeyPress = (value: string) => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current.getVolume().then((volume) => {
                if (value === 'ArrowUp') {
                    volume = volume + 0.2;
                    if (volume >= 1) {
                        volume = 1;
                    } else {
                        volume = volume;
                    }
                } else if (value === 'ArrowDown') {
                    volume = volume - 0.2;
                    if (volume <= 0) {
                        volume = 0;
                    } else {
                        volume = volume;
                    }
                } else if (value === 'mute') {
                    if (volume === 0) {
                        volume = previousVolume.current;
                    } else {
                        previousVolume.current = volume;
                        volume = 0;
                    }
                }
                handleVolumeChange(null, volume);
            });
        }
    };


    const handleVolumeChange = (event: any, initVal: any) => {
        if (vimeoApiPlayerRef.current && volumeBarRef.current) {
            let volume;
            if (event !== null) {
                volume = parseFloat(event.target.value);
            } else {
                volume = parseFloat(initVal);
            }

            if (volume === 0) {
                setVolumeIcon(Mute);
            } else {
                setVolumeIcon(Volume);
            }

            const percent = ((volume - 0) / (1 - 0)) * 100;
            let bgPercentage = percent + '%';
            setVolumeBarChangePer(bgPercentage);
            volumeBarRef.current.value = volume
            if (volume !== 0) {
                previousVolume.current = volume
            }
            vimeoApiPlayerRef.current.setVolume(volume);
        }
    };

    const handleVolumeBtn = () => {
        if (vimeoApiPlayerRef.current) {
            vimeoApiPlayerRef.current.getMuted().then((muted) => {
                if (muted) {
                    handleVolumeChange(null, previousVolume.current);
                } else {
                    handleVolumeChange(null, 0);
                }
            })

            // vimeoApiPlayerRef.current.getVolume().then((volume) => {                
            //     if (volume !== 0) {
            //         previousVolume.current = volume
            //         handleVolumeChange(null, 0);
            //     } else {
            //         handleVolumeChange(null, previousVolume.current);
            //     }
            // });
        }
    };
    // ======= END : fns to volumne =======





    // ======= START : fns to handle full screen =======
    const isFullScreen = () => {
        const currentFullscreenStatus = document.fullscreenElement ||
            (document as any).webkitFullscreenElement ||
            (document as any).msFullscreenElement;
        return currentFullscreenStatus
    }
    const handleFullscreenChange = () => {
        const currentFullscreenStatus = isFullScreen();
        const newIsFullscreen = !!currentFullscreenStatus;
        setFullSmallScreenIcon(newIsFullscreen ? SmallScreen : FullScreen);
        setIsManualFullscreen(newIsFullscreen)
    };


    const toggleFullscreen = () => {
        if (!document.fullscreenElement &&
            !(document as any).webkitFullscreenElement &&
            !(document as any).msFullscreenElement) {
            // Not currently in fullscreen, so enter fullscreen

            const elementToFullscreen = playerContainerRef.current;
            if (elementToFullscreen && elementToFullscreen.requestFullscreen) {
                elementToFullscreen.requestFullscreen();
            } else {
                const iPhoneDivEle = vimeoApiPlayerRef.current;
                if (iPhoneDivEle && iPhoneDivEle.requestFullscreen) {
                    iPhoneDivEle.requestFullscreen();
                }
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if ((document as any).webkitExitFullscreen) { // Safari
                (document as any).webkitExitFullscreen();
            } else if ((document as any).msExitFullscreen) { // IE/Edge
                (document as any).msExitFullscreen();
            }
        }
    };
    // ======= END : fns to handle full screen =======




    // ======= START : util fns =======
    const isInMobileView = () => {
        let status = false
        if (screenWidth < 550) {
            status = true
        }
        return status
    }

    const isInTabView = () => {
        let status = false
        if (screenWidth < 1000) {
            status = true
        }
        return status
    }

    //Fn to handle hiding of popup's when clicked outside the respective container
    const handleOutsideClick = (event: any) => {
        // setDisplayOfSpeedConRef("none")

        // console.log(event.target)
        // if (
        //     speedConRef.current &&
        //     !speedConRef.current.contains(event.target)
        // ) {
        //     console.log('11')
        // } else {
        //     console.log('22')
        // }


        // RMEOVE.....
        // if (
        //     speedContainerRef.current &&
        //     !speedContainerRef.current.contains(event.target)
        // ) {
        //     set_Is_SpeedContainerRef_Visible(false);
        // }
        // if (
        //     qtyContainerRef.current &&
        //     !qtyContainerRef.current.contains(event.target)
        // ) {
        //     set_Is_QtyContainerRef_Visible(false);
        // }
    };
    // ======= END : util fns =======



    // ======= START : INACTIVITY DETECTION FUNCTIONS =======
    const startInactivityTimer = useCallback(() => {
        inactivityTimeoutRef.current = setTimeout(() => {
            if (isFullScreen() && videoIsPlaying.current) {
                setShowControls(false)
            }
        }, INACTIVITY_TIMEOUT_MS);
    }, []);

    const resetInactivityTimer = useCallback(() => {
        if (isFullScreen()) {
            setShowControls(true)
        }
        if (inactivityTimeoutRef.current) {
            clearTimeout(inactivityTimeoutRef.current);
        }
        startInactivityTimer();
    }, [startInactivityTimer]);
    // ======= END : INACTIVITY DETECTION FUNCTIONS =======


    return (
        <>
            <div className='relative'>
                {finalIsLoading &&
                    <div
                        style={{
                            zIndex: 1
                        }}
                        className={`videPlayerLoader animate-pulse ${addCurrentThemeClassToEle(currentTheme, 'videPlayerLoader')}`}>

                        <div className='h-[100%] w-[100%]'>
                        </div>
                    </div>
                }

                <VideoPlayerMainView
                    finalIsLoading={finalIsLoading}

                    domVideoElementRef={domVideoElementRef}
                    handleMouseEnter={handleMouseEnter}
                    handleMouseLeave={handleMouseLeave}
                    showControls={showControls}

                    videoIsPlaying={videoIsPlaying}
                    playPauseIcon={playPauseIcon}
                    miniPlayPauseIcon={miniPlayPauseIcon}
                    handlePlayPauseOfVideo={handlePlayPauseOfVideo}
                    handleBackward10={handleBackward10}
                    handleForward10={handleForward10}
                    isVisibleBackwardIcon={isVisibleBackwardIcon}
                    isVisibleForwardIcon={isVisibleForwardIcon}


                    //START : States for handling video time
                    timeBarRef={timeBarRef}
                    handleTimeBarRefChange={handleTimeBarRefChange}
                    timeBarChangePer={timeBarChangePer}
                    currentVideoTime={currentVideoTime}
                    videoDuration={videoDuration}
                    //END : States for handling video time

                    miniBackwardBtnRef={miniBackwardBtnRef}
                    miniPlayPauseBtnRef={miniPlayPauseBtnRef}
                    //START : States to handle speed
                    handleSpeedContainerVisibility={handleSpeedContainerVisibility}
                    speedList={speedList}
                    speedValue={speedValue}
                    handleSpeed={handleSpeed}
                    speedConRef={speedConRef}
                    speedIcon={speedIcon}
                    //END : States to handle speed


                    //START : States to handle qty
                    handleQtyContainerVisibility={handleQtyContainerVisibility}
                    availableQualities={availableQualities}
                    qtyConRef={qtyConRef}
                    handleQty={handleQty}
                    qtyValue={qtyValue}
                    qtyImgIconRef={qtyImgIconRef}
                    //END : States to handle qty


                    //START : States to handle CC
                    ccIcon={ccIcon}
                    isHasCaptions={isHasCaptions}
                    handleCC={handleCC}
                    //END : States to handle CC


                    //START : States to handle volume
                    volumeBarRef={volumeBarRef}
                    handleVolumeChange={handleVolumeChange}
                    volumeBarChangePer={volumeBarChangePer}
                    volumeIcon={volumeIcon}
                    handleVolumeBtn={handleVolumeBtn}
                    //END : States to handle volume



                    //START : States to handle full screen 
                    toggleFullscreen={toggleFullscreen}
                    playerContainerRef={playerContainerRef}
                    fullSmallScreenIcon={fullSmallScreenIcon}
                    //END : States to handle full screen 

                    isManualFullscreen={isManualFullscreen}


                />
            </div>
        </>
    );
}

